// extracted by mini-css-extract-plugin
export default {"lgtFooter":"Footer_lgtFooter__fLldj","FooterText":"Footer_FooterText__mIWWf","link":"Footer_link__Iu70w","social":"Footer_social__7mIhM"};